'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineQuotationEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _simpleUgcDisplay = require('../../simple-ugc-display');

var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineQuotationEditor = exports.InlineQuotationEditor = function (_BcReactComponent) {
  _inherits(InlineQuotationEditor, _BcReactComponent);

  function InlineQuotationEditor(props) {
    _classCallCheck(this, InlineQuotationEditor);

    var _this = _possibleConstructorReturn(this, (InlineQuotationEditor.__proto__ || Object.getPrototypeOf(InlineQuotationEditor)).call(this, props));

    _this.state = {
      focusInput: false
    };
    return _this;
  }

  _createClass(InlineQuotationEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* for testing purposes */}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.showForm && nextProps.showForm) {
        this.setState({
          focusInput: true
        });
      }
    }
  }, {
    key: 'renderMessaging',
    value: function renderMessaging() {
      var _props = this.props,
          status = _props.status,
          pending = _props.pending;

      var infoMessage = _react2.default.createElement(
        _baseAlerts.AlertInfo,
        null,
        _react2.default.createElement('span', { className: 'icon-spinner' }),
        'Submitting quotation...'
      );
      var successMessage = _react2.default.createElement(
        _baseAlerts.AlertSuccess,
        null,
        'Quotation Saved'
      );
      var failureMessage = _react2.default.createElement(
        _baseAlerts.AlertFailure,
        null,
        _react2.default.createElement('span', { className: 'icon-ok' }),
        'Could not save quotation.'
      );
      return _react2.default.createElement(
        'div',
        null,
        pending ? infoMessage : null,
        status === 'success' ? successMessage : null,
        status === 'failure' ? failureMessage : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          characterLimit = _props2.characterLimit,
          bibId = _props2.bibId,
          isPrivate = _props2.isPrivate,
          handlePrivacyToggle = _props2.handlePrivacyToggle,
          quotation = _props2.quotation,
          handleCancel = _props2.handleCancel,
          handleChange = _props2.handleChange,
          handleDelete = _props2.handleDelete,
          handleShowForm = _props2.handleShowForm,
          handleSubmit = _props2.handleSubmit,
          rating = _props2.rating,
          showForm = _props2.showForm,
          user = _props2.user;


      if (showForm) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-inline-quotation-editor well' },
          this.renderMessaging(),
          _react2.default.createElement(_simpleUgcForm2.default, {
            characterLimit: characterLimit,
            body: quotation,
            handleDelete: handleDelete,
            handleCancel: handleCancel,
            handleChange: handleChange,
            handleSubmit: handleSubmit,
            setFocus: this.state.focusInput,
            isNew: false,
            ugcType: 'quotation',
            placeholderText: 'quotation_field_placeholder',
            submitButtonText: 'update_quotation',
            formHeadingText: 'enter_a_quotation' }),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderMessaging(),
        _react2.default.createElement(_simpleUgcDisplay2.default, {
          bibId: bibId,
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle,
          user: user,
          ugcType: 'quotation',
          body: quotation,
          rating: rating / 2,
          handleDelete: handleDelete,
          handleShowForm: handleShowForm })
      );
    }
  }]);

  return InlineQuotationEditor;
}(_baseBcReactComponent2.default);

InlineQuotationEditor.propTypes = {
  characterLimit: _react.PropTypes.number,
  quotation: _react.PropTypes.string,
  bibId: _react.PropTypes.number.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  handleCancel: _react.PropTypes.func.isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  handleShowForm: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  pending: _react.PropTypes.bool.isRequired,
  rating: _react.PropTypes.number,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }),
  showForm: _react.PropTypes.bool.isRequired,
  status: _react.PropTypes.string.isRequired
};

exports.default = InlineQuotationEditor;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-quotation-editor/components/InlineQuotationEditor.js
// module id = 1518
// module chunks = 1